module.exports = __webpack_public_path__ + "assets/img/video-btn-52a97805.png";